import { render, staticRenderFns } from "./mail-main.vue?vue&type=template&id=bf9a11a8&scoped=true"
import script from "./mail-main.vue?vue&type=script&lang=js"
export * from "./mail-main.vue?vue&type=script&lang=js"
import style0 from "./mail-main.vue?vue&type=style&index=0&id=bf9a11a8&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9a11a8",
  null
  
)

export default component.exports